import { createContext, useContext } from "react";
import {
    createDefaultRsoConstraintLevels,
    IRsoConfigurationPreset,
    IRsoConstraintLevels,
    RsoConfigurationSource
} from "../interfaces/rsoConfiguration";

const defaultRsoLevels = createDefaultRsoConstraintLevels();

export interface IRsoConfigurationContext {
    defaultLevels: IRsoConstraintLevels;
    savedPresets: IRsoConfigurationPreset[];
    selectedPresetId: string | null;
    manualOverrideLevels: IRsoConstraintLevels | null;
    activeLevels: IRsoConstraintLevels;
    activeSource: RsoConfigurationSource;
    activePresetLabel: string;
    isEditorOpen: boolean;
    isBusy: boolean;
    loadError: string | null;
    openRsoConfiguration: () => void;
    closeRsoConfiguration: () => void;
    setSelectedPresetId: (presetId: string | null) => void;
    setManualOverrideLevels: (levels: IRsoConstraintLevels | null) => void;
    clearManualOverrideLevels: () => void;
    savePreset: (args: {
        id?: string;
        name: string;
        description?: string | null;
        levels: IRsoConstraintLevels;
    }) => Promise<IRsoConfigurationPreset | null>;
    deletePreset: (presetId: string) => Promise<void>;
    reloadPresets: () => Promise<IRsoConfigurationPreset[]>;
}

const noopSaveAsync = async () => null;
const noopReloadAsync = async () => [];

const rsoConfigurationContext = createContext<IRsoConfigurationContext>({
    defaultLevels: defaultRsoLevels,
    savedPresets: [],
    selectedPresetId: null,
    manualOverrideLevels: null,
    activeLevels: defaultRsoLevels,
    activeSource: 'default',
    activePresetLabel: 'Default',
    isEditorOpen: false,
    isBusy: false,
    loadError: null,
    openRsoConfiguration: () => {},
    closeRsoConfiguration: () => {},
    setSelectedPresetId: () => {},
    setManualOverrideLevels: () => {},
    clearManualOverrideLevels: () => {},
    savePreset: noopSaveAsync,
    deletePreset: async () => {},
    reloadPresets: noopReloadAsync
});

const useRsoConfiguration = () => useContext(rsoConfigurationContext);

export { rsoConfigurationContext, useRsoConfiguration };
